export enum TooltipType {
    CLASSROOM = 'CLASSROOM',
    ACTIVITY = 'ACTIVITY',
    PACING = "PACING"
}